<template>
    <div>
        <div class="sd">
            <div style="width: 88%; height: 40px; float: left;">
                <span style="font-weight: bold;">技术手段：</span>
                <span style="font-weight: bold; color: rgb(7, 54, 125);">{{ data.detail.techDesc }}</span>
            </div>
            <div style="width: 12%; height: 40px; float: right;">
                <v-ny-level-item :data="data.detail"></v-ny-level-item>
            </div>
        </div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="基本信息" name="1">
                <v-normal-info :data="data"></v-normal-info>
            </el-tab-pane>
            <el-tab-pane :label="claimsPathTitle" name="2">
                <v-long-text-yq :data="data"></v-long-text-yq>
            </el-tab-pane>
            <el-tab-pane label="说明书" name="9">
                <v-long-text-sm :data="data"></v-long-text-sm>
            </el-tab-pane>
            <!-- <el-tab-pane v-if="data.lg !== 1" label="权利人信息" name="6">
                <v-person-info :data="data"></v-person-info>
            </el-tab-pane> -->
            <el-tab-pane v-if="data.lg !== 1" label="法律状态" name="7">
                <v-legal-status :data="data"></v-legal-status>
            </el-tab-pane>
            <el-tab-pane v-if="data.lg !== 1" label="同族专利" name="5">
                <v-family-info :data="data"></v-family-info>
            </el-tab-pane>
            <!-- <el-tab-pane v-if="data.lg !== 1" label="国民经济&新兴产业" name="8">
                <v-chanye :data="data"></v-chanye>
            </el-tab-pane> -->
            <el-tab-pane v-if="data.lg !== 1" label="PDF文件" name="10">
                <v-patent-pdf :data="data"></v-patent-pdf>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import vNormalInfo from './detail/NormalInfo.vue';
import vLongText from './detail/LongText.vue';
import vLongTextSm from './detail/LongTextSm.vue';
import vLongTextYq from './detail/LongTextYq.vue';
import vFamilyInfo from './detail/FamilyInfo.vue';
import vPersonInfo from './detail/PersonInfo.vue';
import vLegalStatus from './detail/LegalStatus.vue';
import vChanye from './detail/Chanye.vue';
import vPatentPdf from './detail/PatentPdf.vue';
import vNyLevelItem from './ZnjjLevelItem.vue';
export default {
    components: {
        vNormalInfo,
        vLongText,
        vFamilyInfo,
        vPersonInfo,
        vLegalStatus,
        vChanye,
        vLongTextSm,
        vLongTextYq,
        vPatentPdf,
        vNyLevelItem
    },
    props: ['data'],
    data() {
        return {
            activeName: '1',
            claimsPathTitle: ''
        }
    },
    created() {
        
    },
    mounted() {
        this.claimsPathTitle = this.data.lg === 0 ? "权利要求" : "首权项权利要求";
    },
    methods: {
    }
}
</script>

<style>
.sd {
    width: 100%;
    height: 40px;
    text-align: left;
    font-size: 12px;
}
.el-dialog__body {
    padding: 10px 20px;
}
</style>